<div [id]="'kolommen-instellen-' + tabelnaam">
  <div class="clear">
    <a id="kolomSelectieKnop" (click)="toonKolomKeuze = !toonKolomKeuze" class="c-pointer">
      <span [hidden]="toonKolomKeuze" class="kolommen_instellen fa fa-plus text-primary border border-primary mr-2"></span>
      <span [hidden]="!toonKolomKeuze" class="kolommen_instellen fa fa-minus text-light bg-primary border border-primary mr-2"></span>
      <span class="font-weight-bold">{{ actionIdInstellen | promptvalue | async }}</span>
    </a>
    <div *ngIf="toonKolomKeuze" id="kolomSelectieUitleg" class="text-small pl-6">
      {{ actionIdInstellenUitleg | promptvalue | async }}
    </div>
  </div>

  <div *ngIf="toonKolomKeuze" id="kolomSelectie" class="mt-3 clear">
    <div class="w-100 clearfix">
      <div class="float-left w-50 container">
        <div id="toonKeuzeAan">{{ actionIdInstellenAan | promptvalue | async }}</div>
        <div id="actief" class="w-100 dragula border border-primary" [dragula]="dragulaId" [(dragulaModel)]="actieveKolommenSleepbaar">
          <div
            *ngFor="let actieveKolom of actieveKolommenSleepbaar"
            (dblclick)="actieveKolom.active = false; ververs()"
            class="px-2 py-1 font-weight-bold kolom-optie border-primary"
            [class.hidable]="actieveKolom.hidable"
            [class.movable]="actieveKolom.movable"
          >
            {{ actieveKolom.actionId | promptvalue | async }}
          </div>
        </div>
      </div>

      <div class="float-left w-50 container">
        <div id="toonKeuzeUit">{{ actionIdInstellenUit | promptvalue | async }}</div>
        <div id="inactief" class="w-100 dragula border border-grijs1" [dragula]="dragulaId" [(dragulaModel)]="inactieveKolommenSleepbaar">
          <div
            *ngFor="let inactieveKolom of inactieveKolommenSleepbaar"
            (dblclick)="inactieveKolom.active = true; ververs()"
            class="px-2 py-1 kolom-optie border-grijs1"
            [class.hidable]="inactieveKolom.hidable"
            [class.movable]="inactieveKolom.movable"
          >
            {{ inactieveKolom.actionId | promptvalue | async }}
          </div>
        </div>
      </div>
    </div>

    <div class="w-100 clearfix mt-3">
      <ng-container *ngIf="heeftResetEnAnnuleerKnop; then allebei; else een_of_geen"></ng-container>

      <ng-template #allebei>
        <div class="float-left w-25 container">
          <button id="reset" class="button wit w-100" (click)="reset()">
            {{ actionIdInstellenReset | promptvalue | async }}
          </button>
        </div>

        <div class="float-left w-25 container">
          <button id="annuleer" class="button wit w-100" [disabled]="!gewijzigd" (click)="annuleer()">
            {{ actionIdInstellenAnnuleer | promptvalue | async }}
          </button>
        </div>
      </ng-template>

      <ng-template #een_of_geen>
        <div class="float-left w-50 container">
          <button *ngIf="heeftResetKnop" id="reset" class="button wit w-100" (click)="reset()">
            {{ actionIdInstellenReset | promptvalue | async }}
          </button>

          <button *ngIf="heeftAnnuleerKnop" id="annuleer" class="button wit w-100" [disabled]="!gewijzigd" (click)="annuleer()">
            {{ actionIdInstellenAnnuleer | promptvalue | async }}
          </button>

          <div *ngIf="heeftGeenResetOfAnnuleerKnop" style="width: 1px; height: 1px"></div>
        </div>
      </ng-template>

      <div class="float-left w-50 container">
        <button *ngIf="heeftBewaarKnop" id="bewaar" class="button w-100" (click)="bewaar()">
          {{ actionIdInstellenBewaar | promptvalue | async }}
        </button>
      </div>
    </div>
  </div>
</div>
